import { BIKES_BASE_PATH, RoutesList } from '@bikes/routes/Routes';
import { Link, useNavigate } from 'react-router-dom';
import { array } from 'zod';

export const TestLandingPage = () => {
  const navigate = useNavigate();
  return (
    <main>
      <div className="flex flex-col gap-x-2">
        <section>
          <ul>
            <li>
              <button
                onClick={() => navigate(`${RoutesList.BIKES_HOME}?type=bikes`)}
              >
                Bikes
              </button>
            </li>
            <li>
              <button
                onClick={() =>
                  navigate(`${RoutesList.BIKES_HOME}?type=hire_bikes`)
                }
              >
                Hire Bikes
              </button>
            </li>
            <li>
              <button
                onClick={() =>
                  navigate(`${RoutesList.BIKES_HOME}?type=hire_scooters`)
                }
              >
                Hire Scooters
              </button>
            </li>
          </ul>
        </section>
      </div>
    </main>
  );
};
